import { h } from 'preact';
import { sendPostMessage } from '../../utils/browserUtils';
import postMessageTypes from '../../constants/messageTypes';

import styles from './StaticContainer.css';


function onCloseClick(ev) {
  ev.preventDefault();

  sendPostMessage({
    messageType: postMessageTypes.USER_CANCELLED,
    messageParams: {
      reason: 'CloseButtonClicked',
    },
  });
}

function StaticContainer(props) {
  let { showClose, hideOverlayBackground } = props;

  if (showClose === undefined) {
    showClose = false;
  }

  if (hideOverlayBackground === undefined) {
    hideOverlayBackground = false;
  }

  return (
    <div class={`${styles['static-container']} ${(!hideOverlayBackground) ? styles['dark-bg'] : ''}`}>
      <div class={`${styles['static-container-inner']} ${styles['shadow']}`}>
        {
          showClose ? (
            <span class={styles['close-button-container']} onClick={onCloseClick}>
              <i class="icon-close" />
            </span>
          ) :
            null
        }
        {
          props.children
        }
      </div>
    </div>
  );
}

export default StaticContainer;



// WEBPACK FOOTER //
// ./components/StaticContainer/StaticContainer.js